import script from "./ProjectEventDates.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectEventDates.vue?vue&type=script&setup=true&lang=js"

import "./ProjectEventDates.vue?vue&type=style&index=0&id=885f561c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-885f561c"]])

export default __exports__